import React from 'react';
import PropTypes from 'prop-types';
import { compact, filter, find, get, isEmpty } from 'lodash';
import { FileThumbnail } from '@unite-us/client-utils';
import { Spinner } from 'common/spinners';
import { env } from 'src/config/env';
import { useFindFileUploads } from 'src/components/Cases/hooks/useFindFileUploads';

const FileMetadata = ({
  fileIconStyle,
  metafields,
  providedService,
}) => {
  const { fileUploads, isLoading } = useFindFileUploads('provided_service', providedService.id);
  const metaFileFields = filter(metafields, ['type', 'file']);
  const metaFileData = compact(metaFileFields.map((field) => find(providedService.metadata, ['field', field.field])));
  const metaFileObj = !isEmpty(metaFileData) ? compact(metaFileFields.map((field) => {
    const value = get(find(providedService.metadata, ['field', field.field]), 'value', []);
    // if metadata 'field' does not exist or metadata 'value' does not exist or is empty
    if (isEmpty(value)) {
      return null;
    }
    const files = compact(value.map((uuid) => find(fileUploads, ['id', uuid])));

    return {
      value: files,
      label: field.label,
    };
  })) : [];
  const metaFileMapping = {};
  metaFileObj.forEach((item) => {
    metaFileMapping[item.label] = true;
  });
  return (
    <>
      {!isEmpty(metaFileObj) && (
        <>
          <hr className="border-dark-fill-blue" />
          <div className="space-y-2">
            {metaFileObj.map((fileField) => (
              <div className="flex" key={fileField.label}>
                <div className="pl-0 col-sm-3">
                  <span className="font-heavy-font text-text-blue">{fileField.label}:</span>
                </div>
                <div className="pl-0 col-sm-9">
                  {isEmpty(fileField.value) && isLoading && <Spinner />}
                  {fileField.value.map((fileObject) => (
                    <div className="flex col-sm-12" key={fileObject.id}>
                      <div className="mr-2">
                        <FileThumbnail style={fileIconStyle} contentType={fileObject.content_type} />
                      </div>
                      <a
                        href={`${env.CORE_BASE_URL}${fileObject.path}`} rel="noreferrer" target="_blank"
                        className="text-action-blue"
                      >
                        {fileObject.filename}
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      {/* Add Empty file types now -- if it is required and it is not in metaFileObj */}
      {isEmpty(metaFileObj) && !isEmpty(metaFileFields) &&
        metaFileFields.filter((fileObject) => get(fileObject, 'validations.required')).length !== 0 && (
          <hr className="border-dark-fill-blue" />
        )}
      {metaFileFields.filter((fileObject) => get(fileObject, 'validations.required') &&
        !Object.keys(metaFileMapping).includes(fileObject.label))
        .map((fileObject) => (
          <div className="flex" key={fileObject.label}>
            <div className="pl-0 col-sm-3">
              <span className="font-heavy-font text-text-blue ui-form-field__label--required">
                {fileObject.label}:
              </span>
            </div>
            <div className="pl-0 col-sm-9">
              <div className="flex col-sm-12">
                <div className="mr-2">
                  <span className="text-red">Required</span>
                </div>
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

FileMetadata.propTypes = {
  fileIconStyle: PropTypes.object,
  metafields: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    field: PropTypes.string,
    label: PropTypes.string,
    validations: PropTypes.shape({
      required: PropTypes.bool,
    }),
  })),
  providedService: PropTypes.shape({
    id: PropTypes.string,
    metadata: PropTypes.arrayOf(PropTypes.shape({
      field: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
    })),
  }),
};

FileMetadata.defaultProps = {
  fileIconStyle: {
    svg: {
      height: '18px',
      width: '14px',
      fill: '#4467AB',
    },
  },
  metafields: [],
  providedService: {},
};

export default FileMetadata;
